import React from 'react';
import FormControlledInput from '../../../../components/inputs/FormInputs/FormControlledInput';
import FormControlledInputArea from '../../../../components/inputs/FormInputs/FormControlledInputArea';
import WrapperButton from '../../../../components/buttons/WrapperButton';
import { useWatch } from 'react-hook-form';
import { ClaimForm } from '@/src/app/Interfaces/Insurance/Claim';

type ContactClamFormProps = {
  fieldIndex: number;
  remove: (index: number) => void;
};

const ContactClaimForm = ({ fieldIndex, remove }: ContactClamFormProps) => {
  const [email, phone, details] = useWatch<ClaimForm>({
    name: [
      `contacts.${fieldIndex}.email`,
      `contacts.${fieldIndex}.phone`,
      `contacts.${fieldIndex}.details`,
    ],
  });

  return (
    <React.Fragment>
      <div className="col-12 pb-0 flex gap-4 align-content-center">
        <label className="text-17px block font-bold">
          Contact {fieldIndex + 1}
        </label>
        <WrapperButton onClick={() => remove(fieldIndex)} type="button">
          <i className="pi pi-trash" />
        </WrapperButton>
      </div>
      <div className="col-12 sm:col-6">
        <label
          htmlFor={`contacts.${fieldIndex}.name`}
          className="text-standard block mb-2"
        >
          Name
        </label>
        <FormControlledInput
          defaultValue=""
          formID={`contacts.${fieldIndex}.name`}
          autocomplete="off"
          isFieldArray={true}
          rules={{
            validate: (value: string) => {
              if (value) {
                return true;
              }

              return phone || email || details ? 'Name is required' : true;
            },
          }}
        />
      </div>
      <div className="col-12 sm:col-6">
        <label
          htmlFor={`contacts.${fieldIndex}.phone`}
          className="text-standard block mb-2"
        >
          Phone Number
        </label>
        <FormControlledInput
          defaultValue=""
          formID={`contacts.${fieldIndex}.phone`}
          autocomplete="off"
        />
      </div>
      <div className="col-12 sm:col-6 mr-auto">
        <label
          htmlFor={`contacts.${fieldIndex}.email`}
          className="text-standard block mb-2"
        >
          Email
        </label>
        <FormControlledInput
          defaultValue=""
          formID={`contacts.${fieldIndex}.email`}
          autocomplete="off"
        />
      </div>
      <div className="col-12">
        <label
          htmlFor={`contacts.${fieldIndex}.details`}
          className="text-standard block mb-2"
        >
          Extra Details
        </label>
        <FormControlledInputArea
          defaultValue=""
          formID={`contacts.${fieldIndex}.details`}
          rows={2}
          cols={60}
        />
      </div>
    </React.Fragment>
  );
};

export default ContactClaimForm;
